import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import theme from '../../theme';
import { adjustColorBrightness } from '../../theme/colors';

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'backgroundColor' || prop !== 'textcolor'
})(({ borderColor, backgroundColor, textcolor, variant }) => ({
  borderColor: borderColor,
  backgroundColor: `${backgroundColor ?? theme.colors.blue} !important`,
  color: `${textcolor ?? theme.colors.white} !important`,
  textTransform: 'none',
  ':hover': {
    filter:
      backgroundColor === theme.colors.white
        ? 'brightness(1)'
        : 'brightness(0.85)',
    borderColor:
      variant === 'outlined' && borderColor
        ? adjustColorBrightness(borderColor, -15)
        : borderColor
  }
}));

StyledButton.propTypes = {
  variant: PropTypes.string,
  borderColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  textcolor: PropTypes.string
};

export default StyledButton;
